import { P } from '@angular/cdk/keycodes';
import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { IDropdownSettings, } from 'ng-multiselect-dropdown';
import { AppService } from 'src/app/services/app/app.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent {
  @Input() fieldCol!: any[]
  @Output() childEvent = new EventEmitter<any[]>();
  public filterArr: any[] = []
  // public fieldCol: any[] = [
  //   { key_name: "First Name", key_val: "first_name", type: 'text' },
  //   { key_name: "Last Name", key_val: "last_name", type: 'text' },
  //   { key_name: "Email", key_val: "email", type: 'text' },
  //   { key_name: "Start Date", key_val: "s_date", type: 'date' },
  //   { key_name: "Department", key_val: "e", type: 'select' },
  // ];
  public filterType: any[] = [
    { val: "contains", key: "Contains", type: ['text'] },
    { val: "doesn't contains", key: "Doesn't contains", type: ['text'] },
    { val: "before", key: "Before", type: ['date'] },
    { val: "after", key: "After", type: ['date'] },
    { val: "is", key: "Is", type: ['text', 'select', 'date'] },
    { val: "is not", key: "Is not", type: ['text', 'select', 'date'] },
    { val: "start with", key: "Starts with", type: ['text'] },
    { val: "end with", key: "Ends with", type: ['text'] },
  ]
  public operand: string = 'or'
  public departmentArr: any[] = [];

  public listArr: any[] = []

  dropdownSettings: IDropdownSettings = {};

  constructor(private cd: ChangeDetectorRef, private userManagementService: UserManagementService,
    private datePipe: DatePipe, private appService: AppService) { }

  ngOnInit(): void {

    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.filterArr = [{ filter_value: '', contains: '', type_value: '' }]
    // let userObj = JSON.parse(this.appService.getData('training-portal.userInfo'));

    this.getDepartmentList()
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

  }

  onOperand(event) {
    if (this.filterArr.length > 0) {
      this.callFilterMethod()
    }
  }
  isObjectEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key].toString().trim() !== "") {
        return false;
      }
    }
    return true;
  }
  onContainValueChange(event: any, item, type?: string) {
    // if the type of filter is category then user need to have the option for the sub category also hence filter the related sub category from the array passed
    // from the main parent component and then assign that to the related object as ["sub_a"]
    //also call filter method sends data back to the main component and triggers the output function
    if (item.filter_value == 'j_c' && type == 'j_c') {
      let selectedItem = item.arr.filter(i => i.j_c == item.type_value);
      item["sub_a"] = selectedItem[0]["sub_a"]
      item["sub_val"] = ''
    }
    this.callFilterMethod()
  }
  onFilterChange(index: number, event: MatSelectChange) {
    let filterVal = event.value

    // if contains is empty then select first value of array
    let filterType = this.fieldCol.find(item => filterVal == item.key_val)["type"]
    let filterListType = this.fieldCol.find(item => filterVal == item.key_val)

    this.filterArr[index]["filter_type"] = filterType
    let newArr: any[] = [...this.filterType]
    // will set the array of contain value based on the column fields selected.
    this.filterArr[index]["array_type"] = newArr.filter(item => item.type.includes(filterType))
    this.filterArr[index]["contains"] = this.filterArr[index]["array_type"][0].val
    this.filterArr[index]["type_value"] = ''

    // if the array value is coming from the another component
    if (filterListType.isCustomArray) {
      // have added this new node name here
      this.filterArr[index]["field_name"] = filterListType["field_name"]
      this.filterArr[index]["key_name"] = filterListType["key_val"]
      this.filterArr[index]["arr"] = filterListType["value"]
      if (filterListType.hasOwnProperty('isSubArr')) {
        this.filterArr[index]["sub_item"] = filterListType["sub_item"]
      }
      // this.filterArr[index]["arr_val"] =  filterListType["key_val"]
    }

  }
  filterOptionsBasedOnItem(index: any): any[] {
    if (this.filterArr[index]["filter_type"]) {
      let newArray = this.filterType.filter(option => option.type.includes(this.filterArr[index]["filter_type"]));
      this.filterArr[index]["contains"] = this.filterType[0].val
      return newArray
    }
    return []
  }
  onTypeChange(index) {
    if ((this.filterArr[index]["filter_value"] != '') && ((this.filterArr[index]["type"] != 'text') && (this.filterArr[index]["type_value"] != ''))) {
      this.callFilterMethod()
    }
  }
  onAddFilter() {
    let obj = { filter_value: '', contains: '', type_value: '' }
    this.filterArr.push(obj);
  }
  onDeleterFilter(i: number) {
    //if no value in filter then don't call API 
    if (this.filterArr.every(this.isObjectEmpty)) {
      this.filterArr.splice(i, 1);
      return
    }
    //if filter value or contains Array is empty don't call API
    // else if ((this.filterArr[i].filter_value == "") && this.filterArr[i]['containsArr'].every(element => element == '')) {
    else if ((this.filterArr[i].filter_value == "") && (this.filterArr[i]['type_value'] == '') || (this.filterArr[i].contains == '')) {
      this.filterArr.splice(i, 1);
      return
    }
    else if ((this.filterArr[i]['type_value'] == '')) {
      this.filterArr.splice(i, 1);
      return
    }
    // call API only if data was filled 
    else {
      this.filterArr.splice(i, 1);
      this.callFilterMethod()
    }
  }
  callFilterMethod() {
    //here parsing and then cloning again to make copy of the array and not to modify the existing array
    let newFilterArr: any[] = JSON.parse(JSON.stringify(this.filterArr));
    // Use the filter method to create a new array without the elements that meet the conditions
    newFilterArr = newFilterArr.filter(obj => {
      // Check the conditions for removald
      if (obj["filter_value"] == '' || obj["contains"] == '' || obj["type_value"] == '') {
        return false; // Exclude this object from the new array
      }
      // Process the "type_value" property
      if (obj["type_value"] != '') {
        if (obj['filter_type'] == 'text') {
          let elements = obj["type_value"].split(',');
          // Use the Array `filter` method to remove empty or whitespace-only elements
          elements = elements.filter(element => element.trim() !== '').map(element => element.trim());
          // Join the filtered elements back into a string with commas
          obj["type_value"] = elements.join(',');
        }
        if (obj['filter_type'] == 'date') {
          obj["type_value"] = this.datePipe.transform(obj["type_value"], 'yyyy-MM-dd')
        }
      }


      if (obj['field_name'] == 'co_i') {
        obj['filter_value'] = obj['field_name']
      }
      delete obj['arr']
      delete obj['filter_type']
      delete obj['array_type']
      return true; // Include this object in the new array
    });
    let filterObj = {
      operand: this.operand,
      arr: newFilterArr
    }
    this.callAPI(filterObj)
  }
  callAPI(obj) {
    this.childEvent.emit(obj)
  }
  getDepartmentList() {
    // this.spinner.show();
    let obj = {}
    this.userManagementService.departmentListing(obj).subscribe((success: any) => {
      // this.spinner.hide();
      if (success.status == 200) {
        this.departmentArr = success.data;
      }
    });
  }

  getFilteredList(item: any): any[] {
    if (!item.arr) return [];
    if (!item.searchText) return item.arr;

    const searchText = item.searchText.toLowerCase();
    return item.arr.filter(dep =>
      (dep[item.filter_value] && dep[item.filter_value].toString().toLowerCase().includes(searchText)) ||
      (dep.name && dep.name.toLowerCase().includes(searchText))
    );
  }

}

